import React, { Component } from "react";
import {
    FormGroup,
    InputGroup,
    RadioGroup,
    Radio,
    TextArea,
    Button,
    Spinner,
    Collapse,
    Icon
} from "@blueprintjs/core";
import UISelect from "../../components-fm/UISelect";
import { GAME_TYPES, HOME_AWAY } from "../../utils/constants";
import './../../css/GameInfoSection.scss'


export default class GameInfoGeneral extends Component {
    state = {
        generalOpen: false
    };


    swapTeams = () => {
        const { game, onChange } = this.props;
        const newHomeAway = game.game_home_away === "acasa" ? HOME_AWAY[1] : HOME_AWAY[0];
        onChange({ home_away: newHomeAway });
    };

    handleChange = (field, value) => {
        if (this.props.onChange) {
            this.props.onChange({ [field]: value });
        }
    };

    handleScoreChange = (field) => (e) => {
        const val = e.target.value.replace(/[^0-9]/g, "");
        this.handleChange(field, val);
    };

    render() {
        const { game } = this.props;
        const teamName = JSON.parse(localStorage.getItem("session"))?.team?.name || "Echipa Mea";
console.log(game)
        if (!game) return <Spinner />;

        return (
            <>

            <div className="game-info-general event-wrapper">
                <div
                    style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 8,  }}
                    onClick={() => this.setState({ generalOpen: !this.state.generalOpen })}
                    className="stats-section "
                >
                    <span className="stats-header-label">Game Info<Icon icon={this.state.generalOpen ? "chevron-up" : "chevron-down"} /></span>
                    
                </div>
                <Collapse isOpen={this.state.generalOpen}>
                        <FormGroup label="Echipe" className="flex-display">
                            <div className="teams-row">
                                <InputGroup
                                    className={`fm-input team-input ${game.game_home_away === "acasa" ? "order-1" : "order-3"}`}
                                    readOnly
                                    value={teamName}
                                />
                                <Button
                                    icon="swap-horizontal"
                                    minimal
                                    onClick={this.swapTeams}
                                    title="Schimbă gazdă / oaspete"
                                    className="swap-btn order-2"
                                />
                                <InputGroup
                                    className={`fm-input team-input ${game.game_home_away === "acasa" ? "order-3" : "order-1"}`}
                                    placeholder="ex: Dinamo"
                                    value={game.game_opponent || ""}
                                    onChange={(e) => this.handleChange("opponent", e.target.value)}
                                />
                            </div>
                        </FormGroup>

                        <FormGroup>
                            <div className="score-row">
                                <InputGroup
                                    className={`fm-input score-input ${game.game_home_away === "acasa" ? "order-1" : "order-3"}`}
                                    type="number"
                                    // min={0}
                                    value={game.game_team_score ?? ""}
                                    onChange={this.handleScoreChange("team_score")}
                                    placeholder="?"
                                />
                                <span className="score-sep order-2">–</span>
                                <InputGroup
                                    className={`fm-input score-input ${game.game_home_away === "acasa" ? "order-3" : "order-1"}`}
                                    type="number"
                                    min={0}
                                    value={game.game_opponent_score ?? ""}
                                    onChange={this.handleScoreChange("opponent_score")}
                                    placeholder="?"
                                />
                            </div>
                        </FormGroup>

                        <div className="row-group">
                            <FormGroup label="Data">
                                <div className="date-wrapper">
                                    <input
                                        type="date"
                                        value={game.event_date || ""}
                                        onChange={(e) => this.handleChange("date", e.target.value)}
                                        style={{ width: "100%" }}
                                    />
                                    <img src="/icons/calendar-white.png" className="calendar-icon" alt="calendar" />
                                </div>
                            </FormGroup>

                            <FormGroup label="Ora">
                                <input
                                    type="time"
                                    step="900"
                                    className="bp5-input"
                                    value={game.event_time || ""}
                                    onChange={(e) => this.handleChange("time", e.target.value)}
                                    style={{ width: "100%" }}
                                />
                            </FormGroup>
                        </div>

                        <FormGroup label="Locație">
                            <InputGroup
                                className="fm-input"
                                placeholder="ex: Teren 1"
                                value={game.location || ""}
                                onChange={(e) => this.handleChange("location", e.target.value)}
                            />
                        </FormGroup>

                        <FormGroup label="Tip joc">
                            <UISelect
                                items={GAME_TYPES}
                                selectedItem={GAME_TYPES.find(opt => opt.id === game.game_type) || GAME_TYPES[0]}
                                onItemSelect={(it) => this.handleChange("game_type", it)}
                            />
                        </FormGroup>

                        <FormGroup label="Descriere / Notițe">
                            <TextArea
                                fill
                                growVertically
                                value={game.description || ""}
                                onChange={(e) => this.handleChange("description", e.target.value)}
                            />
                        </FormGroup>
                </Collapse>
            </div>
            </>
        );
    }
}
